import { PaletteMode } from '@mui/material'

import { darkTheme, lightTheme } from './theme'

export const getTheme = (mode: PaletteMode) => {
  return mode === 'light' ? lightTheme : darkTheme
}
